// Google Consent Mode v2 — nastaví výchozí "denied" co nejdřív a po volbě update.
import type { CategoryDef, ConsentSignal, ConsentState } from './types';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

const ALL_SIGNALS: ConsentSignal[] = [
  'ad_storage',
  'ad_user_data',
  'ad_personalization',
  'analytics_storage',
  'functionality_storage',
  'personalization_storage',
  'security_storage',
];

function ensureGtag(): (...args: unknown[]) => void {
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    // Stejná definice, jakou používá Google snippet — píše do dataLayer.
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer!.push(arguments);
    };
  }
  return window.gtag;
}

/**
 * Zavolat co nejdřív (ideálně z <head> před gtag.js). Nastaví vše na denied
 * kromě security_storage a zapne url_passthrough + ping bez cookies.
 */
export function initConsentDefaults(): void {
  const gtag = ensureGtag();
  const denied: Record<string, 'denied'> = {};
  for (const s of ALL_SIGNALS) {
    if (s !== 'security_storage') denied[s] = 'denied';
  }
  gtag('consent', 'default', {
    ...denied,
    security_storage: 'granted',
    wait_for_update: 500,
  });
  gtag('set', 'url_passthrough', true);
  gtag('set', 'ads_data_redaction', true);
}

/** Přeloží stav kategorií na signály a pošle gtag consent update. */
export function updateConsent(
  state: ConsentState,
  categories: CategoryDef[],
): void {
  const gtag = ensureGtag();
  const granted = new Set<ConsentSignal>(['security_storage']);
  for (const cat of categories) {
    if (state[cat.id]) cat.signals.forEach((s) => granted.add(s));
  }
  const update: Record<string, 'granted' | 'denied'> = {};
  for (const s of ALL_SIGNALS) {
    update[s] = granted.has(s) ? 'granted' : 'denied';
  }
  gtag('consent', 'update', update);
}
